"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const classnames_1 = __importDefault(require("classnames"));
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = __importStar(require("react"));
const react_toastify_1 = require("react-toastify");
const ecommerce_1 = require("../../../api/ecommerce");
const Button_1 = __importDefault(require("../../../common/js/atoms/Button"));
const Icon_1 = __importDefault(require("../../../common/js/atoms/Icon"));
const ButtonVariant_1 = __importDefault(require("../../../common/js/enums/ButtonVariant"));
const Zupicons_1 = __importDefault(require("../../../common/js/enums/Zupicons"));
const array_1 = require("../../../common/js/helper/array");
const string_1 = require("../../../common/js/helper/string");
const translation_1 = require("../../../common/js/helper/translation");
const ShopwareCart_1 = __importDefault(require("../../stores/ShopwareCart"));
const VoucherInput = ({ className }) => {
    const [isCollapsed, setIsCollapsed] = (0, react_1.useState)(true);
    const [isSubmitting, setIsSubmitting] = (0, react_1.useState)(false);
    const [codeInput, setCodeInput] = (0, react_1.useState)('');
    const [submitError, setSubmitError] = (0, react_1.useState)(null);
    const formDisabled = ShopwareCart_1.default.isLoading || isSubmitting || ShopwareCart_1.default.appliedPromotionCode !== '';
    const submitDisabled = formDisabled || codeInput === '';
    const hasSubmitError = submitError !== null;
    const submitVoucher = (event) => {
        event.preventDefault();
        setIsSubmitting(true);
        setSubmitError(null);
        ShopwareCart_1.default
            .addLineItems([
            {
                referencedId: codeInput,
                type: ecommerce_1.LineItemTypeEnum.Promotion,
            },
        ])
            .then(() => {
            const promotionCartErrors = ShopwareCart_1.default.cartErrors.filter((error) => error.level && error.level > 0 && error.messageKey?.indexOf('promotion') !== -1);
            const hasErrors = promotionCartErrors.length > 0;
            if (hasErrors) {
                return Promise.reject(promotionCartErrors);
            }
            react_toastify_1.toast.success((0, translation_1.t)('voucher_input.success_toast'));
        })
            .catch((cartError) => {
            setSubmitError((0, array_1.first)(cartError) ?? null);
        })
            .finally(() => {
            setIsSubmitting(false);
        });
    };
    (0, react_1.useEffect)(() => (0, mobx_1.reaction)(() => ShopwareCart_1.default.appliedPromotionCode, () => {
        setCodeInput(ShopwareCart_1.default.appliedPromotionCode);
    }, { fireImmediately: true }), []);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)('zkp-voucher-input', className) },
        react_1.default.createElement("div", { className: "zkp-voucher-input__collapse-bar", onClick: () => setIsCollapsed(!isCollapsed) },
            react_1.default.createElement("p", { className: "zkp-voucher-input__title" }, (0, translation_1.t)('voucher_input.title')),
            react_1.default.createElement(Icon_1.default, { className: "zkp-voucher-input__icon", name: isCollapsed ? Zupicons_1.default.angleDown : Zupicons_1.default.angleUp })),
        isCollapsed ? null : (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("form", { className: "zkp-voucher-input__form", onSubmit: submitVoucher },
                react_1.default.createElement("input", { type: "text", className: (0, classnames_1.default)('form-control m-0 zkp-voucher-input__input', {
                        'is-invalid': hasSubmitError,
                    }), placeholder: (0, translation_1.t)('voucher_input.input_placeholder'), disabled: formDisabled, value: codeInput, onChange: (event) => setCodeInput(event.target.value) }),
                react_1.default.createElement(Button_1.default, { type: "submit", className: "zkp-voucher-input__button", variant: ButtonVariant_1.default.primary, text: (0, translation_1.t)('voucher_input.submit'), disabled: submitDisabled, loading: isSubmitting })),
            hasSubmitError ? (react_1.default.createElement("div", { className: "invalid-feedback d-block" }, (0, translation_1.t)('voucher_input.error', {
                message_key: (0, string_1.slugifyKey)(submitError?.messageKey, true),
            }))) : null))));
};
exports.default = (0, mobx_react_1.observer)(VoucherInput);
